// @ts-strict-ignore
import { Component } from "@angular/core";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";

@Component({
  selector: C.EWIZ_GENERAL_INFORMATION,
  templateUrl: "./general-information.component.html",
  standalone: false
})
export class EWizGeneralInformationComponent extends EWizDynamicBaseClassComponent {
  update5GElements() {
    if (+this.profileValues.generalInformation.tsaSpec_gte_2p3 === 2) {
      this.profileValues.usimServiceTable.usimService129 = true;
    } else {
      this.profileValues.usimServiceTable.usimService122 = false;
      this.profileValues.usimServiceTable.usimService123 = false;
      this.profileValues.usimServiceTable.usimService124 = false;
      this.profileValues.usimServiceTable.usimService125 = false;
      this.profileValues.usimServiceTable.usimService126 = false;
      this.profileValues.usimServiceTable.usimService127 = false;
      this.profileValues.usimServiceTable.usimService128 = false;
      this.profileValues.usimServiceTable.usimService129 = false;
      this.profileValues.usimServiceTable.usimService130 = false;
      this.profileValues.suciEncryptionScheme.suciCalculation = "3";
    }

    this.handleFormEvents();
  }
}
